
import { Component } from '@theme/component';

const SILENZIO = 120;
const RISALITA_MINIMA = 2;
const TRASCINAMENTO_MINIMO = 40;

class PdpFeature extends Component {
  #indice = 0;
  #armato = true;
  #inDiscesa = false;
  #ultimoEvento = 0;
  #ultimoDelta = 0;

  connectedCallback() {
    super.connectedCallback();
    this.items = Array.from(this.querySelectorAll('[data-feat]'));
    this.mediaSlides = Array.from(this.querySelectorAll('.pdp-feature__slide'));
    this.textSlides = Array.from(this.querySelectorAll('.pdp-feature__text-slide'));
    if (!this.items.length) return;
    this.items.forEach((btn) => btn.addEventListener('click', () => this.select(Number(btn.dataset.feat))));
    const media = this.querySelector('.pdp-feature__media');
    media?.addEventListener('wheel', this.#ruota, { passive: false });
    // il wheel non esiste sul telefono: li si cambia scheda trascinando la foto
    media?.addEventListener('pointerdown', this.#presa);
    media?.addEventListener('pointerup', this.#rilascio);
    media?.addEventListener('pointercancel', () => (this.#partenza = null));
    this.select(0);
  }

  #partenza = null;

  #presa = (event) => {
    // un solo dito per volta: durante un pinch il secondo pointerdown sposterebbe l origine e al
    // rilascio del primo il conto tornerebbe sbagliato, facendo cambiare scheda mentre si zooma
    if (this.#partenza) {
      this.#partenza = null;
      return;
    }
    this.#partenza = { id: event.pointerId, x: event.clientX, y: event.clientY };
    // col mouse il pointerup fuori dall elemento non arriverebbe mai e il gesto resterebbe aperto
    event.currentTarget.setPointerCapture?.(event.pointerId);
  };

  #rilascio = (event) => {
    if (!this.#partenza || event.pointerId !== this.#partenza.id) return;
    const dx = event.clientX - this.#partenza.x;
    const dy = event.clientY - this.#partenza.y;
    this.#partenza = null;
    // solo se il gesto e stato davvero orizzontale, se no era la pagina che scorreva
    if (Math.abs(dx) < TRASCINAMENTO_MINIMO || Math.abs(dx) <= Math.abs(dy)) return;
    const prossimo = this.#indice + (dx < 0 ? 1 : -1);
    if (prossimo < 0 || prossimo >= this.items.length) return;
    this.select(prossimo);
  };

  #ruota = (event) => {
    const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    if (!delta) return;
    const prossimo = this.#indice + (delta > 0 ? 1 : -1);
    if (prossimo < 0 || prossimo >= this.items.length) return;
    event.preventDefault();

    const forza = Math.abs(delta);
    const forzaPrima = Math.abs(this.#ultimoDelta);

    if (event.timeStamp - this.#ultimoEvento > SILENZIO || Math.sign(delta) !== Math.sign(this.#ultimoDelta)) {
      this.#armato = true;
      this.#inDiscesa = false;
    } else if (forza < forzaPrima) {
      this.#inDiscesa = true;
    } else if (this.#inDiscesa && forza > forzaPrima + RISALITA_MINIMA) {
      this.#armato = true;
      this.#inDiscesa = false;
    }

    this.#ultimoEvento = event.timeStamp;
    this.#ultimoDelta = delta;

    if (!this.#armato) return;
    this.#armato = false;
    this.select(prossimo);
  };

  select(i) {
    this.#indice = i;
    this.style.setProperty('--i', i);
    let attivo = null;
    this.items.forEach((btn) => {
      const active = Number(btn.dataset.feat) === i;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-current', active ? 'true' : 'false');
      if (active) attivo = btn;
    });
    this.mediaSlides.forEach((s, n) => s.classList.toggle('is-active', n === i));
    this.textSlides.forEach((s, n) => s.classList.toggle('is-active', n === i));
    if (attivo) this.#portaInVista(attivo);
  }

  // Sul telefono i bottoni stanno in una pista che scorre: dal terzo in poi restano fuori dallo
  // schermo, e cambiando scheda non si vedeva quale fosse quella scelta. La pista lo segue.
  // Muove SOLO la pista. scrollIntoView sposterebbe anche la pagina, e siccome select(0) parte al
  // caricamento la PDP si apriva a meta' altezza. Le rect evitano offsetLeft, che dipende da quale
  // antenato e' posizionato.
  #portaInVista(btn) {
    const pista = btn.parentElement;
    if (!pista || pista.scrollWidth <= pista.clientWidth) return;
    const b = btn.getBoundingClientRect();
    const p = pista.getBoundingClientRect();
    const meta = pista.scrollLeft + (b.left - p.left) - (p.width - b.width) / 2;
    const limite = Math.max(0, Math.min(meta, pista.scrollWidth - pista.clientWidth));
    if (Math.abs(limite - pista.scrollLeft) < 2) return;
    pista.scrollTo({
      left: limite,
      behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
    });
  }
}

if (!customElements.get('pdp-feature-component')) customElements.define('pdp-feature-component', PdpFeature);
